import { render, staticRenderFns } from "./currentOrder.vue?vue&type=template&id=7b0f2d84&"
import script from "./currentOrder.vue?vue&type=script&lang=js&"
export * from "./currentOrder.vue?vue&type=script&lang=js&"
import style0 from "./currentOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports